import axios from "../../utils/axios";

 export const getBlog = async (id) =>{
    const responce = await axios.get(`/blogs/${id}`);
    return responce.data;
 }